import {
  useEngineStatus,
  UseEngineStatusSelector
} from '@surveycake/react-logic-engine';
import { SurveyConfig } from 'app/core/survey-config';
import { disableBeforeunload } from 'app/modules/survey';
import { isInIframe, userAgent } from 'config/system';
import { useEffect } from 'react';

const dirtySelector: UseEngineStatusSelector<boolean> = status => status.dirty;

/**
 * Only trigger beforeunload event if the survey form is
 * dirty(not pristine) or on preview mode or embeded.
 *
 * @remarks
 * `onpagehide` for iOS
 * `onbeforeunload` for others
 */
export function useBeforeunload(surveyConfig: SurveyConfig) {
  const dirty = useEngineStatus(dirtySelector);

  useEffect(() => {
    if (surveyConfig.isPreview() || isInIframe || !dirty) {
      disableBeforeunload();
      return;
    }

    if (userAgent.isIOS) {
      window.onpagehide = () => {};
    } else {
      window.onbeforeunload = () => {
        const { wording } = surveyConfig;
        return wording.common.info.onbeforeunload;
      };
    }

    return disableBeforeunload;
  }, [surveyConfig, dirty]);
}
